module.exports = __webpack_public_path__ + "img/1.fb85e7e8.gif";